<div class="flex-column gap-4">

	<div class="flxRow-center center-block" *ngIf="getPoliciesDataInProcess">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<div class="flex-row justify-content-between gap-3 align-items-end" style="max-width: 1250px; margin-bottom: -46px;" *ngIf="userPolicy">
		<div></div><!--padder-->
		<search-in-page style="width: 30%; min-width: 300px;"
			[searchSelector]="'[searchable]'"
			[titleSelector]="'[s-title]'"
			[subtitleSelector]="'[s-subtitle]'">
		</search-in-page>
	</div>

	<ng-container *ngIf="userPolicy">
		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="fas fa-shield-alt color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Encryption & Message Security</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Encrypt Message Content</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Encryption will be enabled for the content and attachments of sent emails</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="encryptMessageContentToggle"
										 [(model)]="userPolicy.encrypt_content.value"
										 [isDisabled]="userPolicy.encrypt_content.strict"
										 (onChange)="updatePolicy('encrypt_content', userPolicy.encrypt_content)"></toggle-switch-c>

						<div class="flex-column gap-2">
							<div class="flxRow hSpace1">
								<checkbox id="encryptStrict"
										  [(model)]="userPolicy.encrypt_content.strict"
										  (modelChange)="updatePolicy('encrypt_content', userPolicy.encrypt_content)">
									Strict
								</checkbox>
								<span *ngIf="userPolicy.encrypt_content.value && userPolicy.encrypt_content.strict" style="margin-left: 5px; color: #ff8e00;">(All outgoing emails will be encrypted)</span>
							</div>

							<checkbox id="encryptAllowOverride"
									  [isDisabled]="!userPolicy.encrypt_content.strict"
									  tooltipTxt="Outgoing emails will{{userPolicy.encrypt_content.value ? '' : ' not'}} be encrypted by policy. Allow users to override the strict encryption policy in Gmail/Outlook add-ins."
									  [(model)]="userPolicy.encrypt_content.allow_user_revert"
									  (modelChange)="updatePolicy('encrypt_content', userPolicy.encrypt_content)">
								Allow override in add-ins
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Attachments Encryption Policy</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>To improve performance, all attachments larger than 40mb will automatically be encrypted. Opening encrypted attachments will not require any additional steps from the recipient.</span>
					</div>
					<div class="content-container flex-column gap-2">
						<label class="radio-container mb-0" style="display: block; width: fit-content;">Encrypt from sensitivity threshold
							<input type="radio" name="attachmentEncryption" [value]="dic.CONSTANTS.attachmentEncryption.sensitivity"
								   [(ngModel)]="userPolicy.attachment_encryption.value"
								   [checked]="userPolicy.attachment_encryption.value === dic.CONSTANTS.attachmentEncryption.sensitivity">
							<span class="checkmark" style="top: 7px;"></span>
							<input type="number" min="1" max="5" step="0.1"
								   pattern="/^[1-5]\.?[0-9]?$/"
								   style="opacity: 1; border: 1px solid #ccc; border-radius: 4px; padding: 5px; margin-left: 5px; position: relative;"
								   [(ngModel)]="userPolicy.attachment_encryption.threshold"
								   [disabled]="userPolicy.attachment_encryption.value !== dic.CONSTANTS.attachmentEncryption.sensitivity"/>
							<i style="font-weight: 400; margin-left: 3px;" class="far fa-question-circle" tooltip="Only attachments with sensitivity score equal or above the threshold will be encrypted automatically unless if an admin rule is triggered, or if an encryption method has been applied" placement="right"></i>
							<div style="font-size: 11px;">
						<span>
							For more information about the sensitivity engine click <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.knowledge, dic.CONSTANTS.supportPages.knowledgeBase]" [state]="{anchorId: 'Sensitivity_Engine'}">here</a>.
						</span>
							</div>
						</label>
						<label class="radio-container mb-0" style="display: block; width: fit-content;">Always encrypt attachments
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Attachments will always be encrypted regardless of the email's sensitivity score" placement="right"></i>
							<input type="radio" name="attachmentEncryption" [value]="dic.CONSTANTS.attachmentEncryption.always"
								   [(ngModel)]="userPolicy.attachment_encryption.value"
								   [checked]="userPolicy.attachment_encryption.value === dic.CONSTANTS.attachmentEncryption.always">
							<span class="checkmark"></span>
						</label>
						<label class="radio-container mb-0" style="display: inline-block;">Never encrypt attachments
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Attachments will not be encrypted unless if an admin rule is triggered, or if an encryption method has been applied" placement="right"></i>
							<input type="radio" name="attachmentEncryption" [value]="dic.CONSTANTS.attachmentEncryption.never"
								   [(ngModel)]="userPolicy.attachment_encryption.value"
								   [checked]="userPolicy.attachment_encryption.value === dic.CONSTANTS.attachmentEncryption.never">
							<span class="checkmark"></span>
						</label>

						<btn-c class="mt-2"
							   [isDisabled]="updatePolicyInProcess"
							   (action)="updateAttachmentEncryptPolicy();">
							Update
						</btn-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Send encrypted replies as regular emails</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Replies to encrypted emails will be received as regular, unencrypted emails</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="secure_reply_send_regular"
										 [(model)]="userPolicy.secure_reply_send_regular.value"
										 [isDisabled]="userPolicy.secure_reply_send_regular.strict"
										 (onChange)="updatePolicy('secure_reply_send_regular', userPolicy.secure_reply_send_regular)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Strip S/MIME and PGP signatures</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>If S/MIME or PGP signatures are detected, they will be removed from the email so that email content can be encrypted or modified.
When this policy is disabled, emails with S/MIME or PGP signatures will be sent directly without encrypting or modifying the email content.</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="strip_smime_signatures"
										 [(model)]="userPolicy.strip_smime_signatures.value"
										 [isDisabled]="userPolicy.strip_smime_signatures.strict"
										 (onChange)="updatePolicy('strip_smime_signatures', userPolicy.strip_smime_signatures)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow downloading encrypted emails as EML</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Recipients will be able to download encrypted emails as EML files</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="allow_download_as_emlToggle"
										 [(model)]="userPolicy.allow_download_as_eml.value"
										 [isDisabled]="userPolicy.allow_download_as_eml.strict"
										 (onChange)="updatePolicy('allow_download_as_eml', userPolicy.allow_download_as_eml)"></toggle-switch-c>

						<div class="flex-row align-items-center gap-4">
							<div class="flxRow-start align-items-center">
								<checkbox id="allow_download_as_emlStrict"
										  [(model)]="userPolicy.allow_download_as_eml.strict"
										  (modelChange)="updatePolicy('allow_download_as_eml', userPolicy.allow_download_as_eml)">
									Strict
								</checkbox>
								<span *ngIf="userPolicy.allow_download_as_eml.value && userPolicy.allow_download_as_eml.strict" style="margin-left: 5px; color: #ff8e00;">(Downloading EML will be allowed for all outgoing emails)</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-user-check color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Authentication & Access Control</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Require Authentication</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Recipients will need to authenticate their identity before they can access the email</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="requireAuthenticationToggle"
										 [(model)]="userPolicy.secure_send.value"
										 [isDisabled]="userPolicy.secure_send.strict"
										 (onChange)="updatePolicy('secure_send', userPolicy.secure_send)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<div class="flxRow-start align-items-center">
								<checkbox id="requireAuthStrict"
										  [(model)]="userPolicy.secure_send.strict"
										  (modelChange)="updatePolicy('secure_send', userPolicy.secure_send)">
									Strict
								</checkbox>
								<span *ngIf="userPolicy.secure_send.value && userPolicy.secure_send.strict" style="margin-left: 5px; color: #ff8e00;">(All outgoing emails will require authentication)</span>
							</div>

						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Authentication Methods Allowed</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Authentication for encrypted emails will be allowed only using the selected methods</span>
					</div>
					<div class="content-container flex-column gap-2">
						<div class="flex-row flex-wrap justify-content-start gap-3">
							<checkbox *ngFor="let method of allowedAuthMethods"
									  [(model)]="method.selected"
									  style="text-transform: capitalize;">
								{{method.name}}
							</checkbox>
						</div>
						<label *ngIf="userPolicy?.allowed_auth_methods && !userPolicy?.allowed_auth_methods?.includes('email')" style="width: 350px; top: -10px; color: darkorange;">
							Warning: The "Email" method is used as a default in cases where the recipient does not have a registered phone number. If this method is disabled then on those cases, the email will fail to send, and the sender will be notified.
						</label>

						<btn-c class="mt-2"
							   [isDisabled]="updatePolicyInProcess"
							   (action)="updateAuthMethods();">
							Update
						</btn-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Require authentication on replies</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>All encrypted replies will require the recipient to undergo Multi-Factor Authentication</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="secure_received"
										 [(model)]="userPolicy.secure_received.value"
										 [isDisabled]="userPolicy.secure_received.strict"
										 (onChange)="updatePolicy('secure_received', userPolicy.secure_received)"></toggle-switch-c>

						<div class="flex-row align-items-center gap-4">
							<checkbox id="secure_receivedStrict"
									  [(model)]="userPolicy.secure_received.strict"
									  (modelChange)="updatePolicy('secure_received', userPolicy.secure_received)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow recipients to switch authentication from SSO to email</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Users can switch their authentication method from SSO to email.</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="allow_auth_sso_to_email"
										 [(model)]="userPolicy.allow_auth_sso_to_email.value"
										 [isDisabled]="userPolicy.allow_auth_sso_to_email.strict"
										 (onChange)="updatePolicy('allow_auth_sso_to_email', userPolicy.allow_auth_sso_to_email)"></toggle-switch-c>
					</div>
				</div>

				<!-- CC: taken from allow_auth_sso_to_email item above -->
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Smart Authentication</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>We will use a unique fingerprint signature to authenticate the recipient without the MFA step when possible while maintaining maximum security.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="enable_smart_authentication"
										 [(model)]="userPolicy.enable_smart_authentication.value"
										 [isDisabled]="userPolicy.enable_smart_authentication.strict"
										 (onChange)="updatePolicy('enable_smart_authentication', userPolicy.enable_smart_authentication)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="enable_smart_authenticationStrict"
									  [(model)]="userPolicy.enable_smart_authentication.strict"
									  (modelChange)="updatePolicy('enable_smart_authentication', userPolicy.enable_smart_authentication)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-bell color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Message Feedback</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Notify sender about blocked recipients</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Senders will be notified when a recipient has been blocked from accessing an encrypted email</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="notify_sender_email_blocked"
										 [(model)]="userPolicy.notify_sender_email_blocked.value"
										 (onChange)="updatePolicy('notify_sender_email_blocked', userPolicy.notify_sender_email_blocked)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Notify Sender About Blocked Emails</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Senders will be notified when their outbound emails are blocked or quarantined for any reason</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="notifySenderQuarantinedOutbound"
										 [(model)]="userPolicy.notify_sender_outbound_quarantined.enabled"
										 (onChange)="updatePolicyOutboundQuarantinedSenderNotify()"></toggle-switch-c>

						<a class="blue-link" style="text-decoration: underline;" (click)="openNotifyOptionsPopup()">
							Notification Options
						</a>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Notify sender when email is opened</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Sender will receive an email notification when a recipient opens their email</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="on_any_openedToggle"
										 [(model)]="userPolicy.on_any_opened.value"
										 [isDisabled]="userPolicy.on_any_opened.strict"
										 (onChange)="updatePolicy('on_any_opened', userPolicy.on_any_opened)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="on_any_openedStrict"
									  [(model)]="userPolicy.on_any_opened.strict"
									  (modelChange)="updatePolicy('on_any_opened', userPolicy.on_any_opened)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Notify sender when link is clicked</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Sender will receive an email notification when a recipient clicks a link</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="on_link_clickedToggle"
										 [(model)]="userPolicy.on_link_clicked.value"
										 [isDisabled]="userPolicy.on_link_clicked.strict"
										 (onChange)="updatePolicy('on_link_clicked', userPolicy.on_link_clicked)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="on_link_clickedStrict"
									  [(model)]="userPolicy.on_link_clicked.strict"
									  (modelChange)="updatePolicy('on_link_clicked', userPolicy.on_link_clicked)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Notify sender when attachment is downloaded</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Sender will receive an email notification when a recipient downloads an attachment</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="on_attachment_downloadToggle"
										 [(model)]="userPolicy.on_attachment_download.value"
										 [isDisabled]="userPolicy.on_attachment_download.strict"
										 (onChange)="updatePolicy('on_attachment_download', userPolicy.on_attachment_download)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="on_attachment_downloadStrict"
									  [(model)]="userPolicy.on_attachment_download.strict"
									  (modelChange)="updatePolicy('on_attachment_download', userPolicy.on_attachment_download)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-cog color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Message Interaction & Control</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow Updating Messages</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Users will be able to update the content and attachments of sent encrypted emails</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="allowUpdatingMessagesToggle"
										 [(model)]="userPolicy.allow_recall_message.value"
										 [isDisabled]="userPolicy.allow_recall_message.strict"
										 (onChange)="updatePolicy('allow_recall_message', userPolicy.allow_recall_message)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow Recalling Messages</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Users will be able to recall emails sent to internal recipients</span>
					</div>

					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="allow_recall_email"
										 [(model)]="userPolicy.allow_recall_email.value"
										 (onChange)="updatePolicy('allow_recall_email', userPolicy.allow_recall_email)"></toggle-switch-c>
						<div class="flex-row gap-2">
							<span style="line-height: 20px;">Select allowed recall period:</span>
							<input [(ngModel)]="userPolicy.allow_recall_email.max_hours"
								   [disabled]="!userPolicy.allow_recall_email.value"
								   style="width:100px; height:22px; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px;"
								   type="number"
								   (keydown)="handleKeydown($event)"
								   id="allow_recall_email_max_hours" name="allow_recall_email_max_hours"
								   size="5" placeholder="Unlimited">
							<span style="line-height: 20px;">
								Hours
							</span>
							<btn-c style="min-width: 0; margin-left: 10px;"
								   [isDisabled]="!userPolicy.allow_recall_email.value || updatePolicyInProcess"
								   (action)="handlePolicyEmailRecallMaxTimeChange();">
								Update
							</btn-c>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow Admin Policies Only</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Users will not be able to set any protection methods or advanced settings. Only admin policies will apply</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="allow_admin_policy_only"
										 [(model)]="userPolicy.allow_admin_policy_only.value"
										 [isDisabled]="userPolicy.allow_admin_policy_only.strict"
										 (onChange)="updatePolicy('allow_admin_policy_only', userPolicy.allow_admin_policy_only)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Simplified Compose View</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Simplifies the Outlook/Gmail add-in's Compose view, showing only the option to secure the email. This basic mode is enabled by default, but users can switch back to advanced mode at any time.</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="simplified_compose_view"
										 [(model)]="userPolicy.simplified_compose_view.value"
										 (onChange)="updatePolicy('simplified_compose_view', userPolicy.simplified_compose_view)"></toggle-switch-c>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-ban color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Content & Delivery Restrictions</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Block outbound emails to blocklisted recipients</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Outbound emails sent to addresses or domains in your inbound global blocklist will be automatically blocked</span>
					</div>
					<div class="content-container flex-row gap-2 align-items-center">
						<toggle-switch-c id="blockOutboundEmailsBlocklist"
										 [(model)]="userPolicy.block_emails_for_blacklist_senders.value"
										 [isDisabled]="userPolicy.block_emails_for_blacklist_senders.strict"
										 (onChange)="updatePolicy('block_emails_for_blacklist_senders', userPolicy.block_emails_for_blacklist_senders)"></toggle-switch-c>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Block outbound emails for attachment types</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Emails containing those attachment types will be automatically blocked</span>
					</div>
					<div class="content-container flex-column gap-2">
						<div class="flex-row flex-wrap justify-content-start gap-3">
							<checkbox *ngFor="let method of blockFileTypes"
									  [(model)]="method.selected"
									  style="text-transform: capitalize;">
								{{method.name}}
							</checkbox>
						</div>
						<btn-c class="mt-2"
							   [isDisabled]="updatePolicyInProcess"
							   (action)="updateBlockFileTypes();">
							Update
						</btn-c>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Block Inappropriate Content</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Block inappropriate content such as nudity, violence and drug use</span>
					</div>
<!--					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="blockInappropriateContentToggle"
										 [(model)]="userPolicy.block_inappropriate_content.enabled"
										 (onChange)="updateInappropriateContentCategory()"></toggle-switch-c>
					</div>-->
					<div class="content-container flex-column gap-3 f-1-0 mb-4">
						<div class="flex-row align-items-center gap-2" style="flex-wrap: wrap; min-width: 250px;">
							<label class="radio-container m-0">
								Enabled for <b>all</b> mailboxes except:
								<input type="radio" name="smartBannerEnableStatusGroup" [value]="dic.CONSTANTS.groupSelection.all"
									   [(ngModel)]="blockInappropriateContentMode"
									   [checked]="blockInappropriateContentMode === dic.CONSTANTS.groupSelection.all">
								<span class="checkmark"></span>
							</label>
							<app-dropdown-c class="f-1-0 w-ellipsis" style="flex-basis: 250px; max-width: 250px;"
											*ngIf="planUsers?.length"
											[items]="planUsers" itemDisplayKey="email"
											[text]="_.map(_.filter(planUsers, 'selected'), 'email').join(', ')|| 'Select mailboxes (Optional)'"
											[isDisabled]="blockInappropriateContentMode !== dic.CONSTANTS.groupSelection.all"
											[isMultipleSelection]="true"
											[enableSearch]="true">
							</app-dropdown-c>
						</div>

						<label class="radio-container m-0">
							Disabled
							<input type="radio" name="smartBannerEnableStatusGroup" [value]="dic.CONSTANTS.groupSelection.disabled"
								   [(ngModel)]="blockInappropriateContentMode"
								   [checked]="blockInappropriateContentMode === dic.CONSTANTS.groupSelection.disabled">
							<span class="checkmark"></span>
						</label>

						<btn-c class="mt-2"
							   [isDisabled]="updatePolicyInProcess"
							   (action)="updateInappropriateContentCategory();">
							Update
						</btn-c>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Block Malicious Content</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Block sent emails containing malicious content such as links and attachments</span>
					</div>
					<div class="content-container flex-column gap-3">
						<div class="flex-row gap-2 align-items-center">
							<toggle-switch-c id="blockMaliciousContent"
											 [(model)]="userPolicy.malicious_outbound.enabled"
											 [isDisabled]="true"
											 [hideText]="true"></toggle-switch-c>
							<span style="font-size:0.9em; font-style: italic;">(This feature cannot be disabled)</span>
						</div>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Allow Printing</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Recipients will be able to print the content of encrypted emails</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="allowViewingQuarantinedEmailsToggle"
										 [(model)]="userPolicy.enable_print.value"
										 (onChange)="updatePolicy('enable_print', userPolicy.enable_print)"></toggle-switch-c>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-hourglass-half color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Retention & Expiration</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Retention Policy</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Your emails and attachments will be permanently deleted after the selected amount of time</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="retentionPolicyToggle"
										 [(model)]="userPolicy.retention.enabled"
										 (onChange)="updateRetention(true)"></toggle-switch-c>
						<div class="flex-row gap-2">
							<span style="line-height: 20px;">Select period:</span>
							<input required
								   [(ngModel)]="userPolicy.retentionValue"
								   [required]="userPolicy.retention.value"
								   [disabled]="!userPolicy.retention.enabled"
								   style="width:80px; height:22px; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px;"
								   type="number"
								   (keydown)="handleKeydown($event)"
								   id="retention_value" name="retention_value"
								   size="5" placeholder="Number">
							<label style="margin-bottom: 0;">
								<app-dropdown-c style="width: 90px; height: 22px;"
												(click)="retentionType = !retentionType; $event.stopPropagation()"
												[isDisabled]="!userPolicy.retention.enabled"
												text="{{userPolicy.retentionType}}s">
									<li *ngFor="let item of dic.CONSTANTS.timePeriod | keyvalue: gs.returnZero"
										(click)="userPolicy.retentionType = item.value;;"
										id="{{item.value}}">
										{{item.value}}s
									</li>
								</app-dropdown-c>
							</label>

							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-check"
								   [isDisabled]="!userPolicy.retention.enabled || updatePolicyInProcess"
								   (action)="updateRetention();">
							</btn-c>
						</div>
						<span style="font-style: italic; font-size: 11px;">Highest allowed values: 7 years/84 months/2520 days</span>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Email Expiration</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Encrypted emails will expire after the selected amount of days. Expired emails cannot be opened by recipients</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="emailExpirationToggle"
										 [(model)]="userPolicy.expired_enable.value"
										 [isDisabled]="userPolicy.expired_enable.strict"
										 (onChange)="updatePolicy('expired_enable', userPolicy.expired_enable)"></toggle-switch-c>
						<div class="flex-row gap-2 align-items-center">
							<span>Select period:</span>
							<div class="flex-row gap-2 align-items-center">
								<input required
									   [(ngModel)]="userPolicy.expired_days.value"
									   [required]="userPolicy.expired_days"
									   style="width:60px; height: inherit; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px;"
									   [disabled]="!userPolicy.expired_enable.value || userPolicy.expired_enable.strict"
									   type="number"
									   min="1" max="365" pattern="^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$"
									   (keydown)="handleKeydown($event)"
									   id="expired_days" name="expired_days"
									   size="5" placeholder="Days">
								<span>days</span>
							</div>
							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-check"
								   [isDisabled]="!userPolicy.expired_enable.value || userPolicy.expired_enable.strict || updatePolicyInProcess"
								   (action)="updatePolicy('expired_days', userPolicy.expired_days);">
							</btn-c>
						</div>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="expiresInStrict"
									  [(model)]="userPolicy.expired_enable.strict"
									  (modelChange)="updatePolicy('expired_enable', userPolicy.expired_enable)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Attachment Expiration</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Attachments will be automatically deleted after the selected amount of days. Deleted attachments cannot be downloaded by recipients</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="attachmentExpirationToggle"
										 [(model)]="userPolicy.delete_attachment_enable.value"
										 [isDisabled]="userPolicy.delete_attachment_enable.strict"
										 (onChange)="updatePolicy('delete_attachment_enable', userPolicy.delete_attachment_enable)"></toggle-switch-c>
						<div class="flex-row align-items-centerm gap-2">
							<span style="line-height: 20px;">Select period:</span>
							<div class="flex-row align-items-center gap-2">
								<input required
									   [(ngModel)]="userPolicy.delete_attachment_days.value"
									   [required]="userPolicy.delete_attachment_days.value"
									   style="width:60px; height: inherit; margin-bottom:0; box-sizing: border-box; border-radius: 4px; border: 1px solid #ccc; padding: 2px 8px;"
									   [disabled]="!userPolicy.delete_attachment_enable.value || userPolicy.delete_attachment_enable.strict" type="number"
									   min="1" max="365" pattern="^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$"
									   (keydown)="handleKeydown($event)"
									   id="delete_attachment_days" name="delete_attachment_days"
									   size="5" placeholder="Days">
								<span>days</span>
							</div>
							<btn-c style="min-width: 0;"
								   endIcon="zmdi zmdi-check"
								   [isDisabled]="!userPolicy.delete_attachment_days.value || userPolicy.delete_attachment_enable.strict || updatePolicyInProcess"
								   (action)="updatePolicy('delete_attachment_days', userPolicy.delete_attachment_days);">
							</btn-c>
						</div>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="deleteAttachmentStrict"
									  [(model)]="userPolicy.delete_attachment_enable.strict"
									  (modelChange)="updatePolicy('delete_attachment_enable', userPolicy.delete_attachment_enable)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex-column gap-3">
			<div class="flex-row gap-2 align-items-baseline">
				<i class="fas fa-search color-bold" style="font-size: 1.2rem;"></i>
				<h6 class="m-0" style="font-size: 0.95rem; letter-spacing: -0.01em;">Message Tracking</h6>
			</div>
			<div class="ps-5 pb-2 list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Track Links</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Links will be tracked to notify when recipients have clicked on them</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="trackLinksToggle"
										 [(model)]="userPolicy.track_links.value"
										 [isDisabled]="userPolicy.track_links.strict"
										 (onChange)="updatePolicy('track_links', userPolicy.track_links)"></toggle-switch-c>
						<div class="flex-row align-items-center gap-4">
							<checkbox id="trackLinksStrict"
									  [(model)]="userPolicy.track_links.strict"
									  (modelChange)="updatePolicy('track_links', userPolicy.track_links)">
								Strict
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4" searchable>
					<div class="title-section-container flex-column gap-2">
						<b s-title>Email Open Tracking HTML</b>
						<span class="lh-base" style="font-size: 0.9em;" s-subtitle>Add a tracking pixel to monitor when recipients open and read standard emails</span>
					</div>
					<div class="content-container flex-column gap-3">
						<toggle-switch-c id="track_open_html"
										 [(model)]="userPolicy.track_open_html.value"
										 [isDisabled]="userPolicy.track_open_html.strict"
										 (onChange)="updatePolicy('track_open_html', userPolicy.track_open_html)"></toggle-switch-c>
					</div>
				</div>
			</div>
		</div>
	</ng-container>


	<!--Change notification options popup-->
	<popup-c *ngIf="notifyOptionsPopup?.show"
		   head="Sender Release Request Notification"
		   (closeCb)="notifyOptionsPopup = null"
		   (confirmCb)="updatePolicyOutboundQuarantinedSenderNotify()"
		   [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm'}}"
		   size="medium">
		<div class="flxClmn vSpace2 f-1-0">
			<div class="flxClmn vSpace2" style="padding: 0 15px;">
				<div class="flxClmn vSpace1" *ngIf="notifyOptionsPopup">
					<checkbox id="notifyRecipientAllowRequestRelease"
							  tooltipTxt="Recipient quarantine notifications will have a button to automatically send a request to the admin/reviewers to release the email"
							  tooltipDirection="right"
							  [(model)]="userPolicy.notify_sender_outbound_quarantined.block_allow_release_request">
						Allow sender to request release
					</checkbox>
					<div class="flxRow-start hSpace2" style="align-items: center;">
						<div class="flxRow hSpace05" style="align-items: center; flex-basis: 190px;">
							<span style="margin: 0; min-width: 165px;">Send the release request to:</span>
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Optional. If no address is provided here, the request will be sent to the primary reviewer." placement="right"></i>
						</div>
						<input type="text" class="lowerPlaceholder" placeholder="Email addresses separated by commas (optional)" style="margin: 0; width: 100%; box-sizing: inherit; flex: 1 0;"
							   [ngClass]="{'disable': !userPolicy.notify_sender_outbound_quarantined.block_allow_release_request}"
							   [(ngModel)]="notifyOptionsPopup.emails"
							   [disabled]="!userPolicy.notify_sender_outbound_quarantined.block_allow_release_request"/>
					</div>
					<div class="flxRow-start hSpace2">
						<span style="flex-basis: 190px; padding-top: 0.3rem;">Release request email title:</span>
						<div class="flxClmn vSpace05" style="flex: 1 0; margin: 0;">
							<input type="text" class="lowerPlaceholder" placeholder="{{releaseRequestSubjectPlaceholder}}" style="margin: 0; width: 100%; box-sizing: inherit;"
								   [ngClass]="{'disable': !userPolicy?.notify_sender_outbound_quarantined?.block_allow_release_request}"
								   [(ngModel)]="notifyOptionsPopup.notifyAllowRequestSubject"
								   [disabled]="!userPolicy?.notify_sender_outbound_quarantined?.block_allow_release_request"/>
							<span class="text-muted" style="font-size: 0.8rem; line-height: 1.2; max-width: 92%;">{{releaseRequestSubjectDesc}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</popup-c>
</div>

